/**
 * @since 1.0.0
 * @author ApMod Development Team
 */

import { Component, OnInit, Inject, Optional } from '@angular/core';
import { LoggerService } from '../services/logger.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  dialogOptions: any = {
    title: '',
    content: '',
    type: 'alert',
    actions: []
  };


  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              private _logger: LoggerService,
  ) { 

    this.dialogOptions = data;
  }

  ngOnInit(): void {
    
  }


  close(): void {
  }

  actionHandler(callback: any): void {
    if (callback) {
      callback();
    }
  }



}

